import axiosInstance from "../../../axios/Axios";

export function requestAddProduct(action) {
  return () => {
    const formData = action.payload;
    axiosInstance.post(`products/product/create/`, {
      name: formData.name,
      number: formData.number,
      status: formData.status,
      description: formData.description,
    });
  };
}

export function requestGetAllProducts() {
  return axiosInstance.request({
    method: "get",
    url: "products/product/",
  });
}

export function requestEditProduct(action) {
  return () => {
    const data = action.payload;
    axiosInstance.patch(`/products/product/` + data.slug, {
      name: data.name,
      number: data.number,
      status: data.status,
      description: data.description,
      flow: data.elements,
    });
  };
}

export function requestDeleteProduct(action) {
  return () => {
    const data = action.payload;
    console.log(data);
    axiosInstance.delete(`products/product/` + data, {});
  };
}
